import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { portalRoute } from "../_portal.js";

export const portalProjectPlanRoute = createRoute({
  getParentRoute: () => portalRoute,
  path: "/portal/project-plan",
  component: lazyRouteComponent(() => import("./project-plan.page.js"), "PortalProjectPlanPage"),
});
